import React from "react";
import { useSelector } from "react-redux";
import { Modal } from "antd";
import { Button } from 'elements';
import styled from "styled-components";

import ArootahLogo from "assets/images/logo.png";
import useDeviceType from "../../Hooks/ResponsiveHook";

const ConfirmationModal = ({
  availableCredit,
  domain,
  open,
  setOpen,
  handleStart,
}) => {
  const screenSizes = useDeviceType();
  const isMobile = screenSizes === "mobile";
  const isTablet = screenSizes === "iPad";

  const { loading } = useSelector((state) => state.createMasterPlanSelectJourneyReducer);

  const handleCancel = () => {
    setOpen();
  };

  return (
    <>
      <Modal
        open={open}
        footer={false}
        centered
        width={isMobile ? window.innerWidth - 50 : isTablet ? window.innerWidth - 100 : 750}
        onCancel={handleCancel}
      >
        <Wrapper>
          <Logo src={ArootahLogo} alt="Arootah/" />
          <Description>
            Ready to begin? Start your <b>{domain}</b> journey by spending <b>1</b> credit. You currently have <b>{availableCredit}</b> credit(s) remaining.
          </Description>
          <Description>
            Keep in mind that starting a journey requires <b>1</b> credit, and
            further credits will be necessary to initiate additional journeys.
          </Description>
          <Footer>
            <Button onClick={handleStart} disabled={loading}>
              {loading ? "Starting..." : "Start"}
            </Button>
            <Button styleType="link-primary" onClick={handleCancel} disabled={loading}>
              Cancel
            </Button>
          </Footer>
        </Wrapper>
      </Modal>
    </>
  );
};

export default ConfirmationModal;

const Wrapper = styled.div`
  padding: 2rem 4rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.max("sm")`
    padding: 2rem 0rem;
  `}
`;

const Description = styled.p`
  text-align: center;
  font-family: "Inter";
  color: #4c545b;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;

const Logo = styled.img`
  margin-bottom: 2rem;
`;

const Footer = styled.div`
  width: 196px;
  display: flex;
  flex-direction: column;
`;
